












import { defineComponent, PropType } from '@vue/composition-api';
import {
  EpigraphyLabelLink,
  EpigraphyResponse,
  TextDiscourseRow,
} from '@oare/types';
import EpigraphyView from '@/views/Texts/EpigraphyView/index.vue';

export default defineComponent({
  props: {
    epigraphyDetails: {
      type: Object as PropType<EpigraphyResponse>,
      required: true,
    },
    photoUrls: {
      type: Array as PropType<EpigraphyLabelLink[]>,
      required: true,
    },
    localDiscourseInfo: {
      type: Array as PropType<TextDiscourseRow[]>,
      required: true,
    },
  },
  components: {
    EpigraphyView,
  },
  setup() {
    return {};
  },
});
